import ActionTypes from '../actionTypes';

const deactivateSectionControls = (sectionId: string) => ({
  type: ActionTypes.DEACTIVATE_SECTION_CONTROLS,
  sectionId,
});

export default deactivateSectionControls;
